import React from "react";
import Cleave from "cleave.js/react";
import { Props as CleaveProps } from "cleave.js/react/props";

// TypeScript 5.x has stricter JSX component type checking
// This wrapper ensures Cleave works with the newer type system
const TypedCleave = React.forwardRef<HTMLInputElement, CleaveProps>(
  (props, ref) => {
    // Cast to any to bypass the strict type checking while maintaining functionality
    const CleaveComponent = Cleave as any;
    return <CleaveComponent {...props} htmlRef={ref} />;
  }
);

TypedCleave.displayName = "TypedCleave";

export default TypedCleave;